import axios from "@/axios";
import * as authService from "@/services/authService";
import * as constants from "@/constants";
import * as utils from "@/utils";

export async function add(body) {
  return (await axios.post(`/listingTradeSettings/add`, body, {
    headers: await authService.getAuthHeaders()
  })).data.data;
}

export async function edit(body) {
  return (await axios.post(`/listingTradeSettings/edit`, body, {
    headers: await authService.getAuthHeaders()
  })).data.data;
}

export async function getAll() {
  return (await axios.get(`/listingTradeSettings/all`, {
    headers: await authService.getAuthHeaders(),
  })).data.data;
}

export async function cancel(id?: number) {
  return (await axios.post(`/listingTradeSettings/delete`, { id }, {
    headers: await authService.getAuthHeaders()
  })).data.data;
}

export async function editPriorities(data: { id: number, priority: number }[]) {
  return (await axios.post(`/listingTradeSettings/editPriorities`, data, {
    headers: await authService.getAuthHeaders()
  })).data.data;
}
